/** **************************** Import Types ****************************** */
// import { toast } from "react-toastify";
import {
    UPDATE_TIMELINE_REQUEST,
    UPDATE_TIMELINE_SUCCESS,
    UPDATE_TIMELINE_FAILURE,
} from "../types/updateTimeline.types";
import "react-toastify/dist/ReactToastify.css";

export const TimeLineRequest = () => ({
    type: UPDATE_TIMELINE_REQUEST,
});
export const TimeLineSuccess = (users) => ({
    type: UPDATE_TIMELINE_SUCCESS,
    payload: users,
});
export const TimeLineFailure = (error) => ({
    type: UPDATE_TIMELINE_FAILURE,
    payload: error,
});

export const UpdateTimeLine = (
    data
) =>
    async function (dispatch) {
        dispatch(TimeLineRequest());

        if (data) {
            dispatch(TimeLineSuccess({ responseStatus: data }));
            return data;
        } else {
            dispatch(TimeLineFailure({ responseStatus: "failure" }));
        }

    };
